<template>
  <div>
    <div class="operations">
      <div style="flex:1"></div>
      <a-button @click="toAdd">添加</a-button>
    </div>
    <GigaTable :gData="dataSource" :gColumns="columns" />
    <IntroducerForm :visible="showForm" :formData="formState" @formCancel="handleCancel" @formOk="handleOk" />
  </div>
  <div class="form">
    <PosterForm :visible="showPosterForm" :confirmLoading="confirmLoading" :formData="posterFormState" @formCancel="handleCancel"
      @formOk="handlePosterOk" />
  </div>
  <div v-show="imgUrl" class="show-img" @click="handleCancel">
    <img :src="imgUrl" alt="" class="img-poster" @click.stop>
  </div>
  
  <div class="poster">
    <div class="top-left"></div>
    <div class="bg1">
      <svg xmlns="http://www.w3.org/2000/svg" width="375" height="812" viewBox="0 0 375 812" fill="none">
        <path
          d="M-494.178 -235.2C-184.155 -378.588 237.941 -235.609 448.578 84.1018C659.224 403.84 578.654 779.262 268.603 922.659C-41.4197 1066.05 -463.488 923.059 -674.134 603.321C-884.781 283.582 -804.211 -91.8395 -494.178 -235.2ZM253.306 467.702C271.987 380.722 251.458 286.042 195.51 201.144C139.563 116.246 54.9093 51.2413 -42.9019 18.107C-140.676 -15.009 -239.884 -12.2714 -322.242 25.8172C-404.599 63.9058 -460.237 132.759 -478.918 219.74C-497.562 306.738 -477.07 401.4 -421.113 486.325C-365.156 571.251 -280.503 636.256 -182.701 669.362C-84.8893 702.497 14.2908 699.769 96.6485 661.68C179.025 623.554 234.662 554.7 253.306 467.702Z"
          fill="url(#paint0_linear_3669_5113)" fill-opacity="0.6" />
        <defs>
          <linearGradient id="paint0_linear_3669_5113" x1="-245.41" y1="-47.3723" x2="111.911" y2="1006.24"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#08164D" stop-opacity="0" />
            <stop offset="1" stop-color="#1333BA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="map">
      <img :src="posterFormState.url" alt="" crossorigin="anonymous">
    </div>
    <div class="logo">
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M38.5747 20.7035C38.5751 20.7043 38.5753 20.7052 38.5755 20.706C38.9816 22.0589 39.2002 23.4919 39.1977 24.9756C39.1914 30.1627 36.5133 34.7333 32.4703 37.3867C31.932 37.7185 31.3811 38.0317 30.8189 38.326C28.8545 39.2818 26.6499 39.8179 24.3223 39.8149C19.9938 39.8097 16.0953 37.9434 13.3809 34.9766C13.9676 34.1614 14.5959 33.3774 15.2612 32.6255C17.4411 35.2028 20.6942 36.8454 24.3261 36.8498C30.8835 36.8578 36.2246 31.5296 36.2328 24.9722C36.2349 23.411 35.933 21.9195 35.3847 20.5524C29.6693 20.5739 24.1418 22.1931 19.323 25.2812C17.204 26.6391 15.2857 28.2402 13.5928 30.0424L13.5951 30.0476C12.8705 30.8263 12.1842 31.6392 11.5385 32.4842L11.5364 32.4805C10.1003 34.3794 8.88492 36.4503 7.92569 38.6662C7.8452 38.8523 7.75317 39.0777 7.67058 39.2844C6.75328 38.8972 5.86259 38.4597 5 37.978C5.10879 37.7141 5.20459 37.4881 5.20459 37.4881C6.47511 34.553 8.15166 31.8476 10.1741 29.4294C9.72466 28.012 9.48192 26.5037 9.48381 24.9391C9.49387 16.7467 16.1672 10.0899 24.3596 10.1C28.5298 10.105 32.2997 11.8394 34.9969 14.6194C33.5731 14.6419 32.1611 14.7572 30.7665 14.9588C28.916 13.7652 26.7164 13.0682 24.3554 13.0653C17.7982 13.0571 12.4569 18.3853 12.4487 24.9427C12.4479 25.5852 12.5013 26.2151 12.5992 26.8303C14.1596 25.329 15.871 23.9713 17.7232 22.7844C22.8308 19.5116 28.6619 17.7413 34.7028 17.5986C34.9753 17.59 35.2484 17.5854 35.5218 17.5843H35.5666C35.9507 17.5833 36.3353 17.5875 36.7212 17.6026C36.8272 17.6068 36.9329 17.6139 37.0385 17.621C37.0595 17.6224 37.0805 17.6238 37.1015 17.6252C37.1543 17.6283 37.2071 17.6311 37.2599 17.6338L37.2604 17.6346C37.3857 17.8549 37.5042 18.0794 37.6184 18.3065C37.6238 18.317 37.6292 18.3275 37.6346 18.338C37.6455 18.3591 37.6563 18.3802 37.6668 18.4014C37.7737 18.6178 37.8748 18.8374 37.9714 19.0594C37.9896 19.1016 38.0079 19.1435 38.0257 19.1856C38.1202 19.4085 38.2095 19.6338 38.2934 19.8619C38.302 19.885 38.3102 19.9082 38.3184 19.9314C38.3228 19.9439 38.3273 19.9565 38.3317 19.969C38.4185 20.2113 38.5003 20.4557 38.5747 20.7035ZM40.7478 17.9996C42.0263 18.2033 43.2901 18.4809 44.5302 18.8318C44.5302 18.8318 44.7352 18.893 45 18.9741C44.8268 19.9574 44.6 20.9221 44.3243 21.8658C44.1252 21.8031 43.9164 21.7394 43.7227 21.6849C43.0761 21.5019 42.4214 21.3432 41.7619 21.2041C41.5232 20.0945 41.1832 19.0223 40.7478 17.9996Z"
          fill="white" />
      </svg>
    </div>
    <div class="title">
      <div class="t1">GigaWorkshop {{ getTime() }}门店汇总</div>
      <div class="t2">{{ posterFormState.count }} 家直营门店</div>
    </div>
    <div class="ft">
      <div class="qr-w">
        <div class="qr">
          <div class="qr-code">
            <img :src="posterFormState.qrcode" alt="" crossorigin="anonymous">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1.33337" y="1.33325" width="21.3333" height="21.3333" rx="4" fill="black" stroke="white"
                stroke-width="1.5" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M16.6335 10.5334L16.6338 10.5343C16.7724 10.996 16.847 11.4852 16.8462 11.9916C16.844 13.7621 15.9299 15.3222 14.5499 16.2279C14.3661 16.3412 14.1781 16.4481 13.9862 16.5485C13.3157 16.8748 12.5632 17.0578 11.7687 17.0568C10.2912 17.055 8.96053 16.418 8.03402 15.4053C8.23429 15.127 8.44872 14.8594 8.67583 14.6028C9.41988 15.4825 10.5303 16.0432 11.77 16.0447C14.0082 16.0474 15.8313 14.2287 15.8341 11.9905C15.8349 11.4575 15.7318 10.9485 15.5446 10.4818C13.5938 10.4892 11.7071 11.0418 10.0623 12.0959C9.33896 12.5594 8.6842 13.1059 8.10635 13.7211L8.10714 13.7228C7.85979 13.9887 7.62553 14.2661 7.40516 14.5546L7.40444 14.5533C6.91424 15.2014 6.49939 15.9083 6.17198 16.6647C6.1445 16.7282 6.11309 16.8051 6.0849 16.8757C5.77179 16.7435 5.46777 16.5942 5.17334 16.4298C5.21047 16.3397 5.24317 16.2625 5.24317 16.2625C5.67684 15.2607 6.24911 14.3373 6.93943 13.5118C6.78603 13.028 6.70317 12.5132 6.70381 11.9792C6.70725 9.1828 8.98507 6.91063 11.7814 6.91407C13.2049 6.91578 14.4916 7.5078 15.4123 8.4567C14.9263 8.46436 14.4443 8.50371 13.9683 8.57254C13.3367 8.16513 12.5859 7.92723 11.78 7.92623C9.54181 7.92344 7.71862 9.74212 7.71583 11.9804C7.71554 12.1997 7.73379 12.4147 7.7672 12.6247C8.29983 12.1122 8.88397 11.6488 9.51619 11.2437C11.2596 10.1266 13.2499 9.52231 15.3119 9.47359C15.4049 9.47065 15.4981 9.46908 15.5914 9.46872H15.6067C15.7378 9.46836 15.8691 9.46979 16.0008 9.47495C16.037 9.47638 16.073 9.4788 16.1091 9.48123C16.1163 9.48171 16.1234 9.48219 16.1306 9.48267L16.1847 9.48561L16.1849 9.48589C16.2277 9.56109 16.2681 9.63772 16.3071 9.71521C16.3126 9.72602 16.3182 9.73675 16.3236 9.74763C16.3601 9.82146 16.3946 9.89645 16.4276 9.97222L16.4461 10.0153C16.4784 10.0914 16.5089 10.1683 16.5375 10.2461C16.5404 10.254 16.5432 10.2619 16.546 10.2698C16.5475 10.2741 16.549 10.2784 16.5506 10.2827C16.5802 10.3654 16.6081 10.4488 16.6335 10.5334ZM17.3753 9.61046C17.8116 9.68001 18.243 9.77474 18.6663 9.89452C18.6663 9.89452 18.7363 9.91541 18.8267 9.9431C18.7676 10.2787 18.6901 10.608 18.5961 10.9301C18.5281 10.9087 18.4568 10.887 18.3907 10.8684C18.17 10.8059 17.9465 10.7518 17.7214 10.7043C17.6399 10.3255 17.5239 9.95956 17.3753 9.61046Z"
                fill="white" />
            </svg>
          </div>
          <div class="info">
            <div class="user">{{ posterFormState.name }} 邀请购车<span>专属福利</span></div>
            <div class="slogan">
              <div class="s1">{{ posterFormState.giga }}</div>
              <div v-if="posterFormState.type" class="s2">{{ posterFormState.type }}</div>
            </div>
            <div class="hint">微信扫码领取
              <img src="https://file0.52tesla.com/xtbf/fdc662b15d194433beee085c0fb950bb/add861c6" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="ft-ft">
        <svg width="327" height="24" viewBox="0 0 327 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.44279 16.6093H2.3063C1.78242 16.6093 1.35688 16.1838 1.35688 15.6599V13.1509H0V15.6599C0 16.9305 1.03372 17.9642 2.30429 17.9642H13.9422V16.6073H3.79968V14.5078H5.4456V13.1509H3.79968V11.0493H6.72621H7.56925C8.31393 11.0493 8.98233 10.5776 9.23123 9.87308L9.86953 8.06858H8.43035L7.95263 9.42145C7.89442 9.58404 7.74187 9.69243 7.56925 9.69243H6.72621H3.79968V8.33554H5.4456V6.97866H3.79968V6.03125H2.44279V6.97866H0V8.33554H2.44279V9.69243H0V11.0493H2.44279V16.6093Z"
            fill="white" />
          <path
            d="M12.5612 7.79389L12.5632 9.28526C12.5632 9.39365 12.5211 9.49602 12.4448 9.57229C12.3685 9.64857 12.2661 9.69072 12.1578 9.69072H11.2445V11.0476H12.1578C12.6295 11.0476 13.073 10.8629 13.4042 10.5297C13.7374 10.1965 13.9201 9.75294 13.9201 9.28125L13.9181 7.78988C13.9161 6.81838 13.1252 6.02954 12.1557 6.02954H6.7262V7.38643H12.1557C12.3785 7.38843 12.5612 7.56908 12.5612 7.79389Z"
            fill="white" />
          <path
            d="M12.1578 11.728H8.48854C7.51705 11.728 6.7262 12.5189 6.7262 13.4904V14.1688C6.7262 15.1403 7.51705 15.9312 8.48854 15.9312H12.1578C13.1293 15.9312 13.9201 15.1403 13.9201 14.1688V13.4904C13.9201 12.5189 13.1293 11.728 12.1578 11.728ZM12.5652 14.1688C12.5652 14.3936 12.3826 14.5763 12.1578 14.5763H8.48854C8.26373 14.5763 8.08107 14.3936 8.08107 14.1688V13.4904C8.08107 13.2656 8.26373 13.0829 8.48854 13.0829H12.1578C12.3826 13.0829 12.5652 13.2656 12.5652 13.4904V14.1688Z"
            fill="white" />
          <path
            d="M38.9623 13.1511H45.263V11.7942H38.9623V9.69067H37.6054V11.7942H33.607C33.3039 11.7942 33.0249 11.6537 32.8443 11.4109C32.6636 11.166 32.6114 10.8609 32.6997 10.5698L34.0827 6.03149H32.6656L31.4031 10.1744C31.1883 10.8809 31.3168 11.6256 31.7563 12.2178C32.1959 12.8099 32.8703 13.1511 33.609 13.1511H37.6074V14.5763H31.3047V15.9331H37.6074V17.9644H38.9643V15.9331H45.267V14.5763H38.9643V13.1511H38.9623Z"
            fill="white" />
          <path d="M34.7371 8.33779H45.265V6.98291H35.1546L34.7371 8.33779Z" fill="white" />
          <path d="M48.3179 6.03149H46.9611V17.9644H48.3179V6.03149Z" fill="white" />
          <path
            d="M57.6957 6.02954H49.4139V7.38643H57.6957C58.2196 7.38643 58.6452 7.81196 58.6452 8.33584V15.6642C58.6452 16.1881 58.2196 16.6136 57.6957 16.6136H56.7684V17.9705H57.6957C58.9663 17.9705 60 16.9368 60 15.6662V8.33384C60 7.06326 58.9663 6.02954 57.6957 6.02954Z"
            fill="white" />
          <path
            d="M56.7201 14.1707V11.4469C56.7201 10.4754 55.9292 9.68457 54.9577 9.68457H51.1681C50.1966 9.68457 49.4058 10.4754 49.4058 11.4469V14.1707C49.4058 15.1422 50.1966 15.9331 51.1681 15.9331H54.9577C55.9292 15.9331 56.7201 15.1422 56.7201 14.1707ZM51.1661 11.0394H54.9557C55.1805 11.0394 55.3632 11.2221 55.3632 11.4469V12.1354H50.7606V11.4469C50.7606 11.2221 50.9433 11.0394 51.1661 11.0394ZM54.9577 14.5782H51.1681C50.9433 14.5782 50.7606 14.3955 50.7606 14.1707V13.4903H55.3632V14.1707C55.3632 14.3955 55.1806 14.5782 54.9577 14.5782Z"
            fill="white" />
          <path
            d="M15.6423 16.6096V17.9665H19.5624C20.5821 17.9665 21.4673 17.3121 21.7664 16.3386L24.3035 8.06885H22.8844L20.4697 15.9392C20.3473 16.3406 19.982 16.6096 19.5624 16.6096H15.6423Z"
            fill="white" />
          <path
            d="M16.6981 15.9311H18.1052L19.8254 9.69067H17.4448L18.4986 6.03149H17.0875L15.6423 11.0455H18.045L16.6981 15.9311Z"
            fill="white" />
          <path
            d="M24.3437 12.0853C24.0948 12.8441 24.2533 13.663 24.7652 14.2772L25.6443 15.331L24.727 17.9645H26.1622L26.656 16.5454L27.8382 17.9645H29.6046L27.1758 15.052L29.0486 9.67265H27.6134L26.1622 13.8376L25.8049 13.4081C25.5942 13.1552 25.5299 12.818 25.6323 12.5048L27.7479 6.02954H20.7648V7.38643H25.8772L24.3437 12.0853Z"
            fill="white" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M321.516 9.93759L321.516 9.9388C321.711 10.5882 321.816 11.276 321.815 11.9882C321.812 14.478 320.526 16.6719 318.586 17.9455C318.327 18.1048 318.063 18.2551 317.793 18.3964C316.85 18.8552 315.792 19.1125 314.675 19.1111C312.597 19.1086 310.726 18.2128 309.423 16.7887C309.704 16.3974 310.006 16.0211 310.325 15.6602C311.372 16.8973 312.933 17.6857 314.677 17.6878C317.824 17.6916 320.388 15.1341 320.392 11.9866C320.393 11.2372 320.248 10.5213 319.985 9.86504C317.241 9.87541 314.588 10.6526 312.275 12.1349C311.258 12.7867 310.337 13.5552 309.525 14.4202L309.526 14.4228C309.178 14.7966 308.848 15.1868 308.539 15.5923L308.538 15.5905C307.848 16.502 307.265 17.496 306.804 18.5597C306.766 18.649 306.722 18.7572 306.682 18.8564C306.242 18.6706 305.814 18.4606 305.4 18.2294C305.452 18.1027 305.498 17.9942 305.498 17.9942C306.108 16.5853 306.913 15.2868 307.884 14.126C307.668 13.4457 307.551 12.7217 307.552 11.9707C307.557 8.03831 310.76 4.84308 314.693 4.84791C316.694 4.85032 318.504 5.68284 319.799 7.01724C319.115 7.02801 318.437 7.08335 317.768 7.18014C316.88 6.60722 315.824 6.27266 314.691 6.27125C311.543 6.26733 308.979 8.82485 308.975 11.9724C308.975 12.2808 309.001 12.5831 309.048 12.8785C309.797 12.1578 310.618 11.5061 311.507 10.9364C313.959 9.36547 316.758 8.51575 319.657 8.44723C319.788 8.4431 319.919 8.44089 320.05 8.44039H320.072C320.256 8.43988 320.441 8.4419 320.626 8.44914C320.677 8.45115 320.728 8.45457 320.779 8.45798C320.789 8.45866 320.799 8.45934 320.809 8.46001C320.834 8.4615 320.859 8.4628 320.884 8.4641L320.885 8.46413L320.885 8.46453C320.945 8.57029 321.002 8.67805 321.057 8.78702C321.059 8.79206 321.062 8.7971 321.065 8.80214C321.07 8.81226 321.075 8.82238 321.08 8.8326C321.131 8.93644 321.18 9.04188 321.226 9.14844L321.23 9.15745C321.238 9.17465 321.245 9.19179 321.252 9.20901C321.298 9.31597 321.341 9.42413 321.381 9.53361C321.385 9.5447 321.389 9.55584 321.393 9.56696C321.395 9.57299 321.397 9.57901 321.399 9.58502C321.441 9.70134 321.48 9.81866 321.516 9.93759ZM322.559 8.63971C323.173 8.73751 323.779 8.87073 324.375 9.03916C324.375 9.03916 324.473 9.06854 324.6 9.10748C324.517 9.57948 324.408 10.0425 324.276 10.4955C324.18 10.4654 324.08 10.4348 323.987 10.4087C323.677 10.3208 323.362 10.2447 323.046 10.1779C322.931 9.64529 322.768 9.13062 322.559 8.63971Z"
            fill="white" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
// configureReferralExpert 
import { getReferralActivityExperts, configureReferralExpert, updateReferralExpert } from '../http/api'
import GigaTable from '../components/GigaTable.vue'
import IntroducerForm from '../components/form/IntroducerForm.vue'
import PosterForm from '../components/form/PosterForm.vue'
import html2canvas from "html2canvas"


export default {
  components: {
    GigaTable,
    IntroducerForm,
    PosterForm
  },
  data() {
    return {
      confirmLoading: false,
      formState: {},
      posterFormState: {},
      showForm: false,
      visible: false,
      dataSource: [],
      imgUrl: '',
      columns: [{
        title: 'ID',
        dataIndex: 'id',
        key: 'id'
      }, {
        title: '昵称',
        dataIndex: 'nickname',
        key: 'nickname'
      }, {
        title: '手机号',
        dataIndex: 'phoneNum',
        key: 'phoneNum'
      }, {
        title: '欢迎语',
        dataIndex: 'referralWelcomeMsg',
        key: 'referralWelcomeMsg',
        width: 200
      }, {
        title: 'H5引荐码',
        dataIndex: 'referralH5Link',
        key: 'referralH5Link',
        customRender: (val) => {
          return (
            <div>
              <a-image width={60} src={val.value} />
            </div>
          )
        }
      }, {
        title: '小程序引荐码',
        dataIndex: 'referralMiniProgramLink',
        key: 'referralMiniProgramLink',
        customRender: (val) => {
          return (
            <div>
              <a-image width={60} src={val.value} />
            </div>
          )
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        width: 250,
        customRender: (val) => {
          return (
            <div>
              <a-button onClick={() => this.edit(val.record)}>编辑欢迎语</a-button>
              <a-dropdown class="ml12" trigger={['click']} overlay={(
                <a-menu>
                  <a-menu-item onClick={() => this.getPoster(val.record)}>
                    <span>H5引荐码</span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.getPoster(val.record, 'mini')}>
                    <span>小程序引荐码</span>
                  </a-menu-item>
                </a-menu>
              )}>
                <a-button>分享海报</a-button>
              </a-dropdown>
            </div>
          )
        }
      }]
    }
  },
  created() {
    this.getReferralActivityExperts()
  },
  methods: {
    getTime() {
      let date = new Date()
      return `${date.getMonth() + 1}月${date.getDate()}日`
    },
    edit(e) {
      console.log(e)
      this.formState = JSON.parse(JSON.stringify(e))
      this.showForm = true
    },
    getPoster(e, type) {
      console.log(e, type)
      let posterFormState = {
        name: e.nickname,
        qrcode: type == 'mini' ? e.referralMiniProgramLink : e.referralH5Link
      }
      this.posterFormState = posterFormState
      this.showPosterForm = true
    },
    toAdd() {
      this.showForm = true
      this.formState = {}
    },
    handleCancel() {
      this.showForm = false
      this.showPosterForm = false
      this.formState = {}
      this.posterFormState = {}
      this.imgUrl = ''
      this.confirmLoading = false
    },
    async handlePosterOk(e) {
      console.log(e.url)
      try {
        this.confirmLoading = true
        let poster = document.querySelector('.poster')
        this.posterFormState = e
        setTimeout(() => {
          html2canvas(poster, {
            logging: false,
            allowTaint: true,
            scale: window.devicePixelRatio,
            width: poster.offsetWidth,
            height: poster.offsetHeight,
            scrollY: 0,
            scrollX: 0,
            useCORS: true,
            tainttest: true,
            backgroundColor: '#ffffff',
          }).then((canvas) => {
            let imgUrl = canvas.toDataURL("image/png");
            this.handleCancel()
            this.imgUrl = imgUrl
          })
        }, 300)
      } catch (error) {
        this.confirmLoading = true
      }
    },
    async handleOk(e) {
      console.log(e)
      if (!e.id) {
        let res = await configureReferralExpert({ variables: { nickname: e.nickname, phoneNum: e.phoneNum } })
        if (res.errors) {
          this.$message.error(res.errors[0].message)
          return
        }
        this.$message.success('操作成功')
        e.id = res.data.configureReferralExpert.userId
      }
      updateReferralExpert({ variables: { userId: e.id, welcomeMsg: e.referralWelcomeMsg } }).then(res => {
        console.log(res)
        if (res.errors) {
          this.$message.error(res.errors[0].message)
          return
        }
        this.showForm = false
        this.formState = {}
        this.getReferralActivityExperts()
      })
    },
    getReferralActivityExperts() {
      getReferralActivityExperts().then(res => {
        console.log(res)
        if (res.errors) {
          this.$message.error(res.errors[0].message)
          return
        }
        let dataSource = res.data.referralActivityExperts
        this.dataSource = dataSource
      })
    },
    showChannel() {
      this.visible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.ml12 {
  margin-left: 12px;
}

.poster {
  font-size: 0;
  position: absolute;
  top: -9999px;
  left: -99999px;
  width: 375px;
  height: 812px;
  background: #fff;
  margin: auto;
  background: #000;
  overflow: hidden;
  padding: 30px 22px;
  box-sizing: border-box;

  .top-left {
    width: 518px;
    height: 518px;
    flex-shrink: 0;
    border-radius: 518px;
    background: #0031FF;
    filter: blur(197px);
    position: absolute;
    left: -235px;
    top: -403px;
  }

  .logo {
    position: relative;
    z-index: 99;
    font-size: 0;

    svg {
      width: 50px;
      height: 50px;
    }
  }

  .title {
    position: relative;
    z-index: 99;
    margin-top: 14px;

    .t1 {
      color: #FFF;
      font-family: OPlusSans3-400;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .t2 {
      margin-top: 6px;
      color: #FFF;
      font-family: OPlusSans3-500;
      font-size: 28px;
      font-style: normal;
      line-height: normal;
    }
  }

  .bg1 {
    position: absolute;
    top: 0;
    left: 0;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .map {
    position: absolute;
    top: 21px;
    left: 0;

    img {
      width: 100%;
      height: auto;
    }
  }

  .ft {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 30px;

    .qr-w {
      padding: 0 22px;

      .qr {
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.06);
        background: rgba(255, 255, 255, 0.10);
        backdrop-filter: blur(29px);
        padding: 9px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .qr-code {
          width: 96px;
          height: 96px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          svg {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 22px;
            height: 22px;
            margin: auto;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .info {
          text-align: right;
          flex: 1;

          .user {
            color: #FFF;
            text-align: right;
            font-family: OPlusSans3-700;
            font-size: 15px;
            font-style: normal;
            line-height: 140%;

            /* 21px */
            span {
              color: #FF7A00;
            }
          }

          .slogan {
            margin-top: 10px;
            padding: 3px 8px 3px 0;
            border-top-right-radius: 5px;
            border-top-left-radius: 5px;
            border: 0.5px solid rgba(255, 255, 255, 0.12);
            border-left: none;
            background: rgba(255, 255, 255, 0.06);
            box-sizing: border-box;
            width: 100%;

            .s1 {
              color: #FF7A00;
              text-align: right;
              font-family: OPlusSans3-700;
              font-size: 11px;
              font-style: normal;
              line-height: 140%;
              /* 15.4px */
            }

            .s2 {
              margin-top: 2px;
              color: #FFF;
              font-family: OPlusSans3-400;
              color: rgba(255, 255, 255, 0.40);
              font-size: 8px;
              font-style: normal;
              font-weight: 400;
              line-height: 140%;
              /* 11.2px */
            }
          }

          .hint {
            margin-top: 10px;
            color: #FFF;
            font-family: OPlusSans3-400;
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
            /* 11.2px */
            display: flex;
            align-items: center;
            justify-content: flex-end;
            box-sizing: border-box;

            img {
              width: 12px;
              height: 13px;
              margin-left: 5px;
            }
          }
        }
      }
    }

    .ft-ft {
      margin-top: 26px;
      padding: 0 24px;
      box-sizing: border-box;

      svg {
        width: 100%;
        height: auto;
      }
    }
  }
}
.img-poster {
  width: 300px;
  height: auto;
}
.show-img {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
</style>